const PicturesGallery = (target) => {
  const initSlider = ($el, params) => {
    $el.slick(params);
  };
  $('body').find(target)
    .each((_, el) => {
      const $el = $(el);
      const params = {
        slidesToShow: 2,
        variableWidth: false,
        arrows: true,
        prevArrow: '<button class="slick-arrow slick-prev"><i class="icon icon-arrow"></i></button>',
        nextArrow: '<button class="slick-arrow slick-next"><i class="icon icon-arrow"></i></span></button>',
        dots: false,
        infinite: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              centerPadding: '10%',
            },
          },
        ],
      }
      initSlider($el, params);

      $el.on('mousedown', '.slick-list', function () {
        $(this).addClass('grabbing');
      });

      $el.on('mouseup', '.slick-list', function () {
        $(this).removeClass('grabbing');
      });

      $(window).on('resize', () => {
        if (!$el.hasClass('slick-initialized')) {
          initSlider($el, params)
        }
      });
    });
}

export default PicturesGallery;



// WEBPACK FOOTER //
// ./scripts/components/PicturesGallery.js